import * as Controls from './controlsImage';
import * as PanelLib from './panellib/libpanel';
import * as Types from './types';
import * as TSTypeWithPath from './tsTypeWithPath';

export interface PanelContext {
  classSets?: Controls.ClassSetControls;

  // TODO: Get rid of path. It's used by PanelDir. Should we have an "updateInput" ?
  path?: string[];
}

export type UpdateContext = (partialContext: Partial<PanelContext>) => void;

// Panel input is a TSTypeWithPath, which for all input types other than
// Dict, resolves to a {path: QueryPathSingle, value: TSType} object. For
// Dict, we enforce that a path is included with each incoming value of the dict.
// This means that each incoming value, or series of values in the case
// of a dict, must be accompanied by a QueryPathSingle. QueryPathSingle
// can be converted to a query, which can be used to refetch the incoming
// value or values.

// This is the external version of PanelInput, ie, the type the caller
// must conform to when instantiating panels.
export type PanelInput = TSTypeWithPath.PathObjOrDictWithPath<any>;

// This is the Panel's input specifically typed for the given panel. This
// is the type the panel's author will work with when writing code inside
// the panel.
type PanelInputInternal<
  I extends Types.Type
> = TSTypeWithPath.TypeToTSTypeWithPath<I>;

export type PanelProps<
  I extends Types.Type,
  C = undefined
> = PanelLib.PanelProps<PanelInputInternal<I>, C, PanelContext>;

export type PanelSpec = PanelLib.PanelSpec<PanelContext, Types.Type>;

export type PanelConverterProps = PanelLib.PanelConverterProps<
  PanelContext,
  Types.Type
>;
export type PanelConvertSpec = PanelLib.PanelConvertSpec<
  PanelContext,
  Types.Type
>;

export type PanelConvertWithChildSpec = PanelLib.PanelConvertWithChildSpec<
  PanelContext,
  Types.Type
>;

export type PanelSpecNode = PanelLib.PanelSpecNode<PanelContext, Types.Type>;

export const inputIsSingle = TSTypeWithPath.isSinglePathObjTSType;
